import { ReactNode } from 'react';
import styled from 'styled-components';
import { LoaderStreamingComponent } from 'components/common/loader-streaming';
import { DocumentEditor } from 'components/organisms/document-editor/document-editor';
import {
  MeetingPageThinkingLogs,
  type MeetingPageThinkingLogsProps,
} from 'components/pages/meeting-page-template/meeting-page-thinking-log-row';

const Container = styled.div<{ isLoading: boolean }>`
  margin: var(--spacing-08) 0;

  .rte-editor {
    display: ${({ isLoading }) => (isLoading ? 'none' : 'block')};
  }
`;

const TitleSection = styled.section`
  color: var(--text-primary);
  font-size: var(--text-04);
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--spacing-05);
`;

const ErrorContainer = styled.div`
  margin-bottom: var(--spacing-06);
`;

const ThinkingLogsPanel = styled.div`
  width: 100%;
  margin-bottom: var(--spacing-05);
`;

interface PreviewContainerProps {
  isLoading: boolean;
  isInitializingStream: boolean;
  title?: string;
  content: any;
  errorComponent?: ReactNode;
  noContentMessage?: ReactNode;
  onInitialize: (editor: any) => void;
  showStreamingLoader?: boolean;
  thinkingLogs?: MeetingPageThinkingLogsProps;
}

export const PreviewContainer: React.FC<PreviewContainerProps> = ({
  isLoading,
  isInitializingStream,
  title,
  content,
  errorComponent,
  noContentMessage,
  onInitialize,
  showStreamingLoader = true,
  thinkingLogs,
}) => {
  const hasContent =
    content &&
    (!Array.isArray(content) || (Array.isArray(content) && content.length > 0));

  return (
    <Container isLoading={!isInitializingStream}>
      {errorComponent && <ErrorContainer>{errorComponent}</ErrorContainer>}

      {isLoading ? (
        <LoaderStreamingComponent />
      ) : (
        <>
          {title && <TitleSection>{title}</TitleSection>}
          {!hasContent ? (
            noContentMessage
          ) : (
            <>
              {thinkingLogs && (
                <ThinkingLogsPanel>
                  <MeetingPageThinkingLogs
                    descriptions={thinkingLogs.descriptions}
                    isStreaming={thinkingLogs.isStreaming}
                    completedSummaryLabel={thinkingLogs.completedSummaryLabel}
                  />
                </ThinkingLogsPanel>
              )}
              {!isInitializingStream &&
                showStreamingLoader &&
                !thinkingLogs && <LoaderStreamingComponent />}
              <DocumentEditor
                onInitialize={onInitialize}
                value={content}
                readonly={true}
              />
            </>
          )}
        </>
      )}
    </Container>
  );
};
